export default {
  name: 'WarningDiamond',
  dimensions: { width: 24, height: 24 },
  content: `
      <g>
          <path d="M13 5.99994V11.9999H11V5.99994H13Z" fill="currentColor"/>
          <path d="M12 16.9999C12.8284 16.9999 13.5 16.3284 13.5 15.4999C13.5 14.6715 12.8284 13.9999 12 13.9999C11.1716 13.9999 10.5 14.6715 10.5 15.4999C10.5 16.3284 11.1716 16.9999 12 16.9999Z" fill="currentColor"/>
          <path d="M9.87868 1.70705C11.0503 0.535475 12.9498 0.535477 14.1213 1.70705L22.2929 9.87862C23.4645 11.0502 23.4645 12.9497 22.2929 14.1213L14.1213 22.2928C12.9497 23.4644 11.0503 23.4644 9.87868 22.2928L1.70711 14.1213C0.535536 12.9497 0.535538 11.0502 1.70711 9.87862L9.87868 1.70705ZM12.7071 3.12126C12.3166 2.73074 11.6834 2.73074 11.2929 3.12126L3.12132 11.2928C2.7308 11.6834 2.7308 12.3165 3.12132 12.707L11.2929 20.8786C11.6834 21.2691 12.3166 21.2691 12.7071 20.8786L20.8787 12.707C21.2692 12.3165 21.2692 11.6834 20.8787 11.2928L12.7071 3.12126Z" fill="currentColor"/>
      </g>
`
};
